/**
 * @generated SignedSource<<5d54a7bdfecfa9e66c313fb68df1df76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewPreview_widget$data = {
  readonly category: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly content: {
    readonly __typename: "WidgetTodoOverviewContentMedium";
  } | {
    readonly __typename: "WidgetTodoOverviewContentMediumGrouped";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewContentMediumPaginated">;
  readonly " $fragmentType": "WidgetTodoOverviewPreview_widget";
};
export type WidgetTodoOverviewPreview_widget$key = {
  readonly " $data"?: WidgetTodoOverviewPreview_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewPreview_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoOverviewPreview_widget",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped"
            }
          ],
          "type": "WidgetTodoOverviewContentMediumGrouped",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v2/*: any*/)
          ],
          "type": "WidgetTodoOverviewContentMedium",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTodoOverviewContentMediumPaginated"
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};
})();

(node as any).hash = "01a3ee05f4ee104ba7dbc0370546686d";

export default node;
